export default __webpack_public_path__ + "static/media/ISEO_CLASS-6_SYLLABUS_2025-26.4b894727.pdf";